module.exports = require("./ln-CG.d.ts");